
export const getDelivery = (destination, obj) => {
    const index = obj.destination.indexOf(destination);
  
    if (index === -1) return undefined;
  
    return `${obj.destPrice[index]} ${obj.destCurrency[index]}`;
};